<div class="flex flex-col w-full h-full shadow-sm rounded-3xl p-6 gap-6 bg-white">
    <div class="flex flex-row justify-between gap-4 items-start">
        <div class="flex flex-col gap-2 flex-1 min-w-0">
            <span class="font-semibold text-[22px]">Confirmación de pedido</span>
            <span class="text-sm text-secondary-200">Verifica los productos, cantidades y montos asociados a tu pedido.
                Asegúrate de que
                todo esté correcto antes de finalizar la solicitud.</span>
        </div>
        <div class="flex flex-row gap-3 flex-shrink-0">
            <button
                class="rounded-3xl flex items-center border-2 px-4 py-3 gap-3 bg-white hover:bg-gray-100 text-primary-300 font-semibold cursor-pointer"
                (click)="addMoreProducts()">
                <span class="text-base flex justify-center items-center">Agregar Productos</span>
                <i class="fi-rr-plus text-2xl flex justify-center items-center"></i>
            </button>
            <button
                class="rounded-3xl flex items-center border-2 px-4 py-3 gap-3 bg-white hover:bg-gray-100 text-primary-300 font-semibold cursor-pointer"
                (click)="saveAsDraft()">
                <span class="text-base flex justify-center items-center">Guardar Pedido</span>
                <i class="fi-rr-disk text-2xl flex justify-center items-center"></i>
            </button>
        </div>
    </div>
    @if (activeWarehouse()) {
      <div class="flex items-center w-full rounded-2xl p-4 gap-4 bg-background-warning">
        <div class="flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0">
          <i class="fi-rr-warehouse text-2xl flex text-warning"></i>
        </div>
        <div class="flex flex-col">
          <span class="font-semibold text-base text-warning">{{ activeWarehouse()?.name }}</span>
        </div>
      </div>
    }
    <div class="overflow-x-auto flex-grow">
        <ng-container *ngIf="cartItems && cartItems.length > 0; else emptyList">
            <div class="card h-full">
                <p-table [value]="cartItems" [paginator]="true" [rows]="rows" [first]="first"
                    (onPage)="onPageChange($event)" [sortField]="sortField" [sortOrder]="sortOrder"
                    currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                    [showCurrentPageReport]="true" [tableStyle]="{ 'min-width': '50rem', 'height': '100%' }">
                    <ng-template pTemplate="header">
                        <tr>
                            <th pSortableColumn="name" class="px-4 py-2 text-left font-semibold text-base">Producto
                                <p-sortIcon field="name"></p-sortIcon>
                            </th>
                            <th pSortableColumn="unitPrice" class="px-4 py-2 text-left font-semibold text-base">Valor
                                Unitario <p-sortIcon field="unitPrice"></p-sortIcon></th>
                            <th pSortableColumn="quantity" class="px-4 py-2 text-left font-semibold text-base">Cantidad
                                <p-sortIcon field="quantity"></p-sortIcon>
                            </th>
                            <th pSortableColumn="totalPrice" class="px-4 py-2 text-left font-semibold text-base">Valor
                                Total <p-sortIcon field="totalPrice"></p-sortIcon></th>
                            <th class="px-4 py-2 text-left font-semibold text-base">Acción</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                        <tr class="hover:bg-orange-50">
                            <td class="px-4 py-2 gap-8">
                                <div class="flex items-start gap-3">
                                    <img role="presentation" class="rounded-lg flex-shrink-0 object-cover"
                                        [alt]="item.name"
                                        [src]="item.productImage || '/asset/imagen-no-disponible-1.jpg'" width="80"
                                        height="80" />
                                    <div class="flex flex-col">
                                        <div class="font-semibold text-sm leading-tight">{{ item.name }}</div>
                                        <div class="text-[11px] text-gray-500 mt-0.5">
                                            ID: {{ item.id }}
                                        </div>
                                        <div *ngIf="item.description"
                                            class="text-[11px] text-gray-500 mt-0.5 break-words whitespace-normal">
                                            {{ item.description || '-'}}
                                        </div>
                                        <div class="text-xs text-text-secondary mt-0.5 break-words whitespace-normal">
                                            {{ getItemSize(item) }}
                                        </div>
                                        <div class="text-xs text-text-secondary mt-0.5 break-words whitespace-normal">
                                            {{ getItemFeatures(item) }}
                                        </div>
                                        <div *ngIf="item.faceOne || item.faceTwo"
                                            class="text-[11px] text-text-secondary mt-0.5">
                                            Caras: {{ getItemCoating(item) }}
                                        </div>
                                        <div *ngIf="item.sku" class="text-[11px] text-text-secondary mt-0.5">
                                            {{ item.sku }}
                                        </div>
                                    </div>
                                </div>
                            </td>

                            <td class="text-sm px-4 py-2">${{ item.price | number:'1.2-2' }}</td>

                            <td class="text-sm px-4 py-2">{{ item.quantity }}</td>

                            <td class="text-sm px-4 py-2">${{ (item.price * item.quantity) | number:'1.2-2' }}
                            </td>

                            <td class="px-4 py-2">
                                <div class="flex flex-row w-full p-4 gap-2">
                                    <i class="fi fi-rr-edit text-2xl text-black hover:text-gray-600 cursor-pointer"
                                        title="Editar" (click)="openProductDetailByCartItem(item)"></i>
                                    <i class="fi-rr-trash text-2xl text-red-600 hover:text-red-800 cursor-pointer"
                                        title="Eliminar" (click)="removeItemFromTheCart(item.id, item.name)"></i>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7">
                                <div class="bg-yellow-100 p-4 rounded-2xl">No hay registros</div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </ng-container>
        <ng-template #emptyList>
            <div class="flex flex-col w-full h-full gap-6">
                <div class="h-full w-full flex flex-col justify-center items-center">
                    <div
                        class="flex flex-row justify-center items-center w-auto h-auto rounded-[36px] p-4 bg-orange-50">
                        <div class="flex flex-row w-auto h-auto">
                            <i class="fi-rr-box-open text-4xl text-red-900"></i>
                        </div>
                    </div>

                    <div class="text-center">
                        <span class="font-semibold text-2xl">Sin productos por el momento</span>
                    </div>

                    <div class="text-center">
                        <span class="text-sm">Agrega lo que necesitas para comenzar. Todo lo que elijas se mostrará
                            aquí.</span>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
    <div class="flex items-center w-full rounded-2xl p-4 gap-4 bg-background-warning">
        <div class="flex items-center justify-center w-10 h-10 rounded-full flex-shrink-0">
            <i class="fi fi-sr-exclamation text-2xl flex text-warning"></i>
        </div>
        <div class="flex flex-col">
            <span class="font-semibold text-base text-warning">{{ leadTime }} días</span>
            <span class="text-xs">Tiempo estimado de entrega.</span>
        </div>
    </div>
    <div class="flex flex-row w-full h-auto gap-6 justify-end">
        <div class="flex flex-col w-auto h-auto gap-1">
            <span class="font-semibold text-sm">Total</span>
            <span class="font-semibold text-2xl text-primary-300">${{ total | number:'1.2-2' }}</span>
        </div>
        <button [disabled]="!(cartItems && cartItems.length > 0) || total <= 0"
            class="flex flex-row w-auto h-auto rounded-3xl pt-4 pb-4 pr-6 pl-6 gap-3 bg-primary-300 hover:bg-primary-400 text-white font-semibold cursor-pointer disabled:bg-gray-200 disabled:cursor-not-allowed"
            (click)="confirmOrder()">
            <span class="text-base flex justify-center items-center">Realizar Pedido</span>
        </button>
    </div>
</div>